export default __webpack_public_path__ + "static/realWorldImg4-a75443b9f8f8a3f8b642cd20c1f8bd4e.png";